import {checkAuth} from 'shared/auth/actions';
import {getJsonAsync} from 'shared/actions';
import {
  displayEventPriceDetailModal,
  setEventPriceDetailData
} from 'shared/eventPriceDetailsModal/actionTypes';
import {
  setTitle,
  setSubTitle
} from 'shared/topBanner/actionTypes';
import {loadReservationReview} from './review/actionTypes';
import {
  retrieveActiveTournaments,
  resetScreenToInitialState,
  handleDateSelection
} from './schedule/actions';
import {updateTotal} from './schedule/actionTypes';
import {setTournamentInformation} from './actionTypes';
import {setSearchResultInState} from './home/actionTypes';
import {
  loadCaptainDetails,
  clearPaymentLogs,
  loadCaptainTournamentEntries
} from './captainDetail/actions';
import {
  resetCaptainDetails,
  setAffectedVirtualEntries
} from './captainDetail/actionTypes';
import {
  retrieveEntryDetails,
  retrieveEntryCaptainDetails,
  retrieveEntryCoordinatorDetails
} from './entryDetail/actions';
import {displayPaymentLogHistory} from './entryDetail/actionTypes';
import {
  getVirtualEventDetailInfo,
  retrieveVirtualEntries
} from './virtualEventDetail/actions';
import { 
  setVirtualEntriesInState
} from './virtualEventDetail/actionTypes';
import {handleSearch} from './home/actions';
import {
  clearAdminAuditSearch
} from './audit/actionTypes';
import {
  loadEntryAudit
} from './audit/entryAudit/actions';
import {
  loadVirtualEntryAudit
} from './audit/virtualEntryAudit/actions';
import {
  loadBowlerAudit
} from './audit/bowlerAudit/actions';
import {
  loadTournamentAudit
} from './audit/tournamentAudit/actions';
import {
  loadCaptainAudit
} from './audit/captainAudit/actions';

export const handleAdminVirtualEventDetailRouteEnter = (nextState, replace, callback) => dispatch =>
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const {captainId, virtualEventId, paymentId} = nextState.params; 

    // Clear the header and details 
    dispatch(setTitle(`Virtual Event`));
    dispatch(setSubTitle(`Captain`));
    dispatch(setVirtualEntriesInState(undefined));

    dispatch(getVirtualEventDetailInfo(captainId, virtualEventId, paymentId))
    .then(response => {
      dispatch(setTitle(`Virtual Event: ${response.virtualEventName}`));
      dispatch(setSubTitle(`Captain: ${response.captainName}`));
      dispatch(retrieveVirtualEntries(captainId, virtualEventId));
    });
  });

export const handleAdminReviewRouteEnter = (nextState, replace, callback) => dispatch =>
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setTitle('Tournament Administration'));
    dispatch(setSubTitle('Reservation Review'));
    dispatch(retrieveTournamentInfo(tournamentId));
    dispatch(loadReservationReview(getAdminShoppingCart()));
  })
  .catch(() => {});

export const handleAdminSquadsRouteEnter = (...args) => (dispatch, getState) =>
  dispatch(checkAuth(...args))
  .then(() => {
    dispatch(setTitle('Tournament Administration'));
    dispatch(setSubTitle('Reserve Squads'));

    const isReturning = getState().admin.base.returningToCalendar;
    const selectedDate = getState().admin.schedule.calendar.selectedDate;

    if (isReturning && selectedDate) {
      dispatch(handleDateSelection(selectedDate));
    }
    else if (!isReturning) {
      dispatch(retrieveActiveTournaments());
      dispatch(setTournamentInformation(null));
      dispatch(resetScreenToInitialState());
    }
   
    dispatch(updateTotal(getAdminShoppingCart()));
  })
  .catch(() => {});

export const handleAdminHomeRouteEnter = (...args) => dispatch =>
  dispatch(checkAuth(...args))
  .then(() => {
    dispatch(setTitle('Tournament Administration'));
    dispatch(setSubTitle(''));
    dispatch(setSearchResultInState(null));
  })
  .catch(() => {});

export const handleAdminBackToSearchRouteEnter = (...args) => (dispatch, getState) =>
  dispatch(checkAuth(...args))
  .then(() => {
    dispatch(setTitle('Tournament Administration'));
    dispatch(setSubTitle(''));
    if (getState().admin.home.searchValue) {
      dispatch(handleSearch());
    }
  })
  .catch(() => {});

export const handleAuditHomeRouteEnter = (...args) => (dispatch) =>
  dispatch(checkAuth(...args))
  .then(() => {
    dispatch(setTitle('Audit'));
    dispatch(setSubTitle(''));
    dispatch(clearAdminAuditSearch());
  })
  .catch(() => {});

export const handleAuditEntryRouteEnter = (nextState, replace, callback) => dispatch =>
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const entryId = nextState.params.entryId;

    dispatch(setTitle('Audit'));
    dispatch(setSubTitle('Entry'));
    dispatch(loadEntryAudit(entryId));
  })
  .catch(() => {});

export const handleAuditVirtualEntryRouteEnter = (nextState, replace, callback) => dispatch =>
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const virtualEntryId = nextState.params.virtualEntryId;

    dispatch(setTitle('Audit'));
    dispatch(setSubTitle('Virtual Entry'));
    dispatch(loadVirtualEntryAudit(virtualEntryId));
  })
  .catch(() => {});
  
export const handleAuditBowlerRouteEnter = (nextState, replace, callback) => dispatch =>  
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const bowlerId = nextState.params.bowlerId;

    dispatch(setTitle('Audit'));
    dispatch(setSubTitle('Bowler'));
    dispatch(loadBowlerAudit(bowlerId));
  });

export const handleAuditTournamentRouteEnter = (nextState, replace, callback) => dispatch =>  
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const tournamentId = nextState.params.tournamentId;

    dispatch(setTitle('Audit'));
    dispatch(setSubTitle('Tournament'));
    dispatch(loadTournamentAudit(tournamentId));
  });
 
export const handleAuditCaptainRouteEnter = (nextState, replace, callback) => dispatch =>  
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const captainId = nextState.params.captainId;
    const tournamentId = nextState.params.tournamentId;

    dispatch(setTitle('Audit'));
    dispatch(setSubTitle('Tournament'));
    dispatch(loadCaptainAudit(captainId, tournamentId));
  });

export const handleAdminEntryDetailRouteEnter = (nextState, replace, callback) => dispatch =>
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const entryId = nextState.params.entryId;
    const paymentId = nextState.params.paymentId;

    dispatch(retrieveEntryDetails(entryId, paymentId))
    .then(entryDetails => {
      dispatch(retrieveEntryCaptainDetails(entryDetails.captainId));
      dispatch(retrieveEntryCoordinatorDetails(entryDetails.coordinatorId));
      dispatch(setTitle(`Entry # ${entryDetails.entryNumber} (${entryDetails.eventDisplayName} event)`));
      dispatch(setSubTitle(`${entryDetails.teamName}`));
    });

    dispatch(displayPaymentLogHistory(false));
  })
  .catch(() => {});

export const handleAdminCaptainDetailRouteEnter = (nextState, replace, callback) => dispatch =>
  dispatch(checkAuth(nextState, replace, callback))
  .then(() => {
    const captainId = nextState.params.captainId;
    const paymentId = nextState.params.paymentId;

    dispatch(resetCaptainDetails());
    dispatch(setAffectedVirtualEntries([]));
    dispatch(loadCaptainDetails(captainId));
    dispatch(clearPaymentLogs());
    dispatch(loadCaptainTournamentEntries(captainId, paymentId));
  })
  .catch(() => {});

export const handleSquadFeesButtonClick = (eventPrice, eventAddOnFees) => dispatch => {
  dispatch(displayEventPriceDetailModal());
  dispatch(setEventPriceDetailData(eventPrice, eventAddOnFees));
};

export const getAdminShoppingCart = () => {
  const cart = JSON.parse(localStorage.adminCart || null) || {};

  return {
    ...cart,
    squads: cart.squads || [],
    virtualEvents: cart.virtualEvents || []
  };
};

export const setAdminShoppingCart = (updatedCart, tournamentId) => () => {
  updatedCart.tournamentId = tournamentId;
  localStorage.adminCart = JSON.stringify(updatedCart);
};

export const retrieveTournamentInfo = tournamentId => dispatch => new Promise((resolve, reject) => {
  dispatch(getJsonAsync(`admin/tournament/${tournamentId}`))
  .then(tournament => {
    dispatch(setTournamentInformation(tournament));
    resolve(tournament);
  })
  .catch(error => reject(error));
});
  


// WEBPACK FOOTER //
// ./src/features/admin/actions.js